import { BreakpointObserver } from '@angular/cdk/layout';

import { Component, inject, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from 'app/services/language.service';
import {
  LANGUAGE_FLAGS,
  LanguageCode,
  LANGUAGES,
} from 'app/statics/language-config';
@Component({
    selector: 'app-header',
    imports: [
    MatMenuModule,
    MatToolbarModule,
    TranslateModule,
    MatIconModule,
    RouterModule,
    MatButtonModule
],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  selectedLanguage: Signal<LanguageCode>;
  readonly LANGUAGE_FLAGS = LANGUAGE_FLAGS;
  readonly LANGUAGES = LANGUAGES;
  private _languageService: LanguageService = inject(LanguageService);
  private _router: Router = inject(Router);
  isMobile = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router
  ) {
    this.selectedLanguage = this._languageService.getCurrentLanguage();
    this.breakpointObserver
      .observe(['(max-width: 450px)'])
      .subscribe((result) => {
        this.isMobile = result.matches;
      });
  }

  get showLogoButton(): boolean {
    return !(this.router.url === '/');
  }

  links = [
    {
      label: 'CONTACT',
      routerLink: null,
      action: () => this.redirectToContactURL(),
    },
    { label: 'REGISTER_BUSINESS', action: () => this.redirectToBusinessUrl() },
    { label: 'FOR_TIRE_SHOPS', action: () => this.redirectToBusinessUrl() },
  ];

  private getBusinessLangPath(lang: LanguageCode): string {
    // default language (de) has no path
    return lang === 'de' ? '' : `/${lang}`;
  }

  private getContactLangSuffix(lang: LanguageCode): string {
    // default language (de) has no suffix
    return lang === 'de' ? '' : `-${lang}`;
  }

  redirectToBusinessUrl() {
    const lang = this.selectedLanguage();
    const path = this.getBusinessLangPath(lang);
    window.open(`https://business.captire.com${path}`, '_blank', 'noopener,noreferrer');
  }

  redirectToContactURL() {
    const lang = this.selectedLanguage();
    const suffix = this.getContactLangSuffix(lang);
    window.open(`https://business.captire.com/contact${suffix}`, '_blank', 'noopener,noreferrer');
  }

  routeToLandingPage() {
    this._router.navigate(['/']);
  }

  changeLanguage(lang: LanguageCode): void {
    this._languageService.changeLanguage(lang);
  }
}
